import type { AiPreferences, DerivedAiStatus } from '@timelyapp/integration-cloud-api-spec';

type OnChangeAiPreferences = {
  type: 'aiPreferences';
  payload: AiPreferences;
};

export type AiPreferencesOnChangePayloads = OnChangeAiPreferences;
export type AiPreferencesOnSubmitPayloads = AiPreferencesOnChangePayloads;

export enum AiPreferencesViews {
  GeneralSettings = 'general',
  Debug = 'debug',
}

export type AiPreferencesProps = {
  /**
   * Initial preferences to load into the form.
   */
  initialPreferences?: AiPreferences;
  debugMode?: boolean;
  onClose: () => void;
  onChange?: (change: AiPreferencesOnChangePayloads) => void;
  onSubmit: (config: AiPreferencesOnSubmitPayloads) => void;
  onSetView?: (view: AiPreferencesViews) => void;
  onError?: (error: any) => void;
  onReset?: () => void;
  toggleDebug?: () => void;
  derivedAiStatus: DerivedAiStatus;
  timelyAccountId: number;
};

export type AiPreferencesViewProps = AiPreferencesProps & {};
